import $ from 'jquery';
// import './orbitcontrols';
// import './jquery-threesixty';
import {View360} from './view-360-int';
import {Slider} from '../../js/librairies/slider/slider';
import {EMIT_UPDATED_CHANGED, EMIT_ZOOM_DISABLED, EMIT_ZOOM_ENABLED, Zoom} from '../../js/librairies/zoom/zoom';

class ModalView360 {

    ready() {
        this.containerImg = document.querySelector('#threesixty-360');
        if (!this.containerImg) {
            return;
        }
        this.zoomRange = document.querySelector('#zoom-slider');
        this.nextPicture = document.querySelectorAll('.next-picture');
        this.prevPicture = document.querySelectorAll('.prev-picture');
        this.zoomUpButton = document.querySelector('#zoom-in');
        this.zoomDownButton = document.querySelector('#zoom-out');
        this.zoomSlider = document.querySelector('#zoom-slider');
        this.changePictureSlider = document.querySelector('#change-picture');

        this.stepSlider = this.zoomSlider.getAttribute('step') !== 'any' ? Number(this.zoomSlider.getAttribute('step')) : 0.1;
        this.zoomMin = Number(this.zoomSlider.getAttribute('min'));
        this.zoomMax = Number(this.zoomSlider.getAttribute('max'));
        this._initViewExterior();
        this._initViewInterior();
        this._initSwitchViewInteriorExterior();
    }

    _initViewExterior() {
        this.availableViewExterior = document.querySelector('#threesixty-360') !== null;
        if (!this.availableViewExterior) {
            return;
        }

        this.slider = new Slider('#threesixty-360', {
            speed: 50
        });

        this.slider.on('loaded', () => {
            this.slider.play(1);
        });

        this.slider.on('picture-change', (index, img) => {
            this.zoom = new Zoom(img, {
                regexReplace: /(\/m|\/xl|\/l|\/xxl)/,
                zoomMin: this.zoomMin,
                zoomMax: this.zoomMax,
                levelQuality: {
                    1: '/l',
                    2: '/xl',
                    4: '/xxl'
                }
            });
            this.zoom.on(EMIT_ZOOM_ENABLED, () => {
                this.slider.disabledEvent();
            }).on(EMIT_ZOOM_DISABLED, () => {
                this.slider.enabledEvent();
            }).on(EMIT_UPDATED_CHANGED, () => {
                this.zoomRange.value = this.zoom.currentZoom;

            });
            this.changePictureSlider.value = index;
        });

        ['touchstart', 'click'].forEach(event => {
            this.containerImg.addEventListener(event, () => {
                this.containerImg.classList.add('active');
            });
        });

        this.changePictureSlider.addEventListener('input', () => {
            this.slider.goto(this.changePictureSlider.value);
            this.containerImg.classList.add('active');
        });

        this.nextPicture.forEach(next => {
            next.addEventListener('click', () => {
                this.containerImg.classList.add('active');
                if (this.changePictureSlider.value != this.changePictureSlider.max){
                    this.slider.next();
                }
            });
        });
        this.prevPicture.forEach(prev => {
            prev.addEventListener('click', () => {
                this.containerImg.classList.add('active');
                if (this.changePictureSlider.value != this.changePictureSlider.min){
                    this.slider.prev();
                }
            });
        });
        this._initZoom();
    }

    _initZoom() {
        this.zoomRange.addEventListener('input', event => {
            if (this.zoom) {
                this.zoom.setZoom(Number(event.currentTarget.value), 50, 50);
            }
        });

        this.zoomUpButton.addEventListener('click', () => {
            if (Number(this.zoomSlider.value) < this.zoomMax) {
                this.zoomSlider.value = Number(this.zoomSlider.value) + this.stepSlider;
                this.zoomSlider.dispatchEvent(new Event('input', {bubbles: true}));
            }
        });

        this.zoomDownButton.addEventListener('click', () => {
            if (this.zoomSlider.value > this.zoomMin) {
                this.zoomSlider.value = Number(this.zoomSlider.value) - this.stepSlider;
                this.zoomSlider.dispatchEvent(new Event('input', {bubbles: true}));
            }
        });
    }

    _initViewInterior() {
        this.availableViewInterior = document.querySelector('#interior-360-player') !== null;
        if (!this.availableViewInterior) {
            return;
        }

        this.view360Interior = new View360('#interior-360-player');
    }

    _initSwitchViewInteriorExterior() {
        if (!this.availableViewExterior && !this.availableViewInterior) {
            return;
        }

        this.goTo360ExteriorPlayerButton = document.querySelector('#go-to-360-exterior-player');
        this.goTo360InteriorPlayer = document.querySelector('#go-to-360-interior-player');

        this.viewInterior = document.querySelector('#interior-360-player');
        this.viewExterior = document.querySelector('#threesixty-360');

        if (this.goTo360ExteriorPlayerButton) {
            this.goTo360ExteriorPlayerButton.addEventListener('click', e => {
                e.preventDefault();
                this._goViewExterior();
                this.viewExterior.classList.remove('active');
            });
        }

        if (this.goTo360InteriorPlayer) {
            this.goTo360InteriorPlayer.addEventListener('click', e => {
                e.preventDefault();
                this._goViewInterior();
            });
        }
    }

    _goViewExterior() {
        if (!this.availableViewExterior) {
            return;
        }

        this._toggleButton(true);
    }

    _goViewInterior() {
        if (!this.availableViewInterior) {
            return;
        }

        this._toggleButton(false);
        this.view360Interior.init('interior-360-player-canvas');
        this.view360Interior.setSize($(window).width(), $(window).height());
        // Show Interior player
        this.viewInterior.innerHTML = '';
        this.viewInterior.insertAdjacentElement('afterbegin', this.view360Interior.getCanvas());
    }

    _toggleButton(exterior = true) {
        if (exterior) {
            if (this.goTo360ExteriorPlayerButton) {
                this.goTo360ExteriorPlayerButton.classList.add('active');
            }
            if (this.goTo360InteriorPlayer) {
                this.goTo360InteriorPlayer.classList.remove('active');
            }
            if (this.viewInterior) {
                this.viewInterior.style.display = 'none';
            }
            if (this.viewExterior) {
                this.viewExterior.style.display = 'block';
            }

        } else {
            if (this.goTo360ExteriorPlayerButton) {
                this.goTo360ExteriorPlayerButton.classList.remove('active');
            }
            if (this.goTo360InteriorPlayer) {
                this.goTo360InteriorPlayer.classList.add('active');
            }
            if (this.viewInterior) {
                this.viewInterior.style.display = 'block';
            }
            if (this.viewExterior) {
                this.viewExterior.style.display = 'none';
            }
        }
    }

    prepareSlider() {
        this.slider.prepare();
    }

    prepareView(selector = '') {
        if (!selector || this.viewExterior && this.viewExterior.id === selector.substring(1)) {
            this.prepareSlider();
            this._goViewExterior();
        } else if (this.viewInterior && this.viewInterior.id === selector.substring(1)) {
            this._goViewInterior();
        }
    }
}

$(document).ready(function () {

    const modalView360 = new ModalView360();
    modalView360.ready();

    $('#modal360').on('show.bs.modal', function (ev) {
        modalView360.prepareView(ev.relatedTarget ? ev.relatedTarget.dataset.tab : '');
    });
});
